import React from "react";
import { Bubble, LineChart33, PictureWall, Pies3 } from "./charts";

export const Benchmark = () => (
  <svg viewBox="0 0 108 136">
    <LineChart33 x={8} y={8} />

    <Bubble x={8} y={40} />

    <Pies3 x={8} y={94} />

    <PictureWall x={8} y={126} />
  </svg>
);
